import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  error: null,
  coupons: [],
  storeCoupon: {},
  updateCoupon: {},
  deleteCoupon: {},
};

const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    loadCouponsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadCouponsSuccess(state, action: any) {
      state.loading = false;
      state.error = null;

      state.coupons = action?.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadCouponsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    storeCouponRequested(
      state,
      action: PayloadAction<{
        id: any;
        name: string;
        fromDate: any;
        priceLimit: any;
        percentage: any;
        typeOf: string;
        couponRef: string;
        isActive: boolean;
        createAt: string;
        toDate: any;
        description: string;
      }>
    ) {
      state.loading = true;
      state.error = null;
    },
    storeCouponSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeCoupon = action.payload;
    },
    storeCouponFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateCouponRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateCouponSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateCoupon = action.payload;
    },
    updateCouponFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    assignCouponRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    assignCouponSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateCoupon = action.payload;
    },
    assignCouponFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    deleteCouponRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteCouponSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteOffer = action.payload;
    },
    deleteCouponFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadCouponsRequested,
  loadCouponsSuccess,
  loadCouponsFail,
  storeCouponRequested,
  storeCouponSuccess,
  storeCouponFail,
  updateCouponRequested,
  updateCouponSuccess,
  updateCouponFail,
  assignCouponRequested,
  assignCouponSuccess,
  assignCouponFail,
  deleteCouponRequested,
  deleteCouponSuccess,
  deleteCouponFail,
} = couponSlice.actions;

export default couponSlice.reducer;
